module.exports = __webpack_public_path__ + "img/customercommentBgSm.66d0f4e6.png";